import { TerraIconName } from '@ninety/terra';

import { PlanLevel } from './plan-level';

export type DowngradingLostFeature = { icon: TerraIconName; copy: string };

export const DowngradingFeaturesLost: Record<string, DowngradingLostFeature[]> = {
  [`${PlanLevel.Thrive}_To_${PlanLevel.Freemium}`]: [
    { icon: 'one-on-one', copy: 'Meetings & 1-1 Conversations' },
    { icon: 'chart-donut', copy: 'Scorecards, Rocks, To-Dos & Issues' },
    { icon: 'learn', copy: 'Documentation & Process' },
  ],
  [`${PlanLevel.Accelerate}_To_${PlanLevel.Freemium}`]: [
    { icon: 'one-on-one', copy: 'Meetings & 1-1 Conversations' },
    { icon: 'rocks', copy: 'Rocks, To-Dos, & Issues' },
    { icon: 'lightbulb', copy: 'Scorecards & Reporting' },
  ],
  [`${PlanLevel.Essentials}_To_${PlanLevel.Freemium}`]: [
    { icon: 'meetings', copy: 'Weekly Meetings' },
    { icon: 'chart-area', copy: 'Scorecards' },
    { icon: 'rocks', copy: 'Rocks, To-Dos & Issues' },
  ],
  [`${PlanLevel.Thrive}_To_${PlanLevel.Accelerate}`]: [
    { icon: 'mountains', copy: 'Rock Draft Assistant' },
    { icon: 'meetings', copy: 'Meeting Assistant' },
    { icon: 'learn', copy: 'Documentation & Process' },
  ],
  [`${PlanLevel.Thrive}_To_${PlanLevel.Essentials}`]: [
    { icon: 'mountains', copy: 'Rock Draft Assistant' },
    { icon: 'meetings', copy: 'Meeting Assistant' },
    { icon: 'learn', copy: 'Documentation & Process' },
  ],
  [`${PlanLevel.Accelerate}_To_${PlanLevel.Essentials}`]: [
    { icon: 'meetings', copy: 'Quarterly, Annual & Custom Meetings' },
    { icon: 'one-on-one', copy: 'Quarter, Annual & Custom Conversations' },
    { icon: 'lightbulb', copy: 'Reporting & Insights' },
  ],
};
